import { render, staticRenderFns } from "./CorrespondenceNew.vue?vue&type=template&id=eb46e178&scoped=true&"
import script from "./CorrespondenceNew.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceNew.vue?vue&type=script&lang=js&"
import style0 from "./CorrespondenceNew.vue?vue&type=style&index=0&id=eb46e178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb46e178",
  null
  
)

export default component.exports